export const INSURANCE_COMPANIES_STATS_EVENTS = {
  INSURANCE_COMPANIES_STATS_AMOUNT: 'insurance-companies-stats-amount',
  INSURANCE_COMPANIES_STATS_COUNT: 'insurance-companies-stats-count',
  INSURANCE_COMPANIES_STATS_EARNINGS: 'insurance-companies-stats-earnings',
};

export const INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS = {
  INSURANCE_COMPANIES_PRODUCT_FILTER_ALL: 'insurance-companies-filter-product-all',
  INSURANCE_COMPANIES_PRODUCT_FILTER_OSAGO: 'insurance-companies-filter-product-osago',
  INSURANCE_COMPANIES_PRODUCT_FILTER_GREEN_CARD: 'insurance-companies-filter-product-green-card',
  INSURANCE_COMPANIES_PRODUCT_FILTER_TOURISM: 'insurance-companies-filter-product-tourism',
  INSURANCE_COMPANIES_PRODUCT_FILTER_HOME: 'insurance-companies-filter-product-home',
  INSURANCE_COMPANIES_PRODUCT_FILTER_EXTERNAL: 'insurance-companies-filter-product-external',
  INSURANCE_COMPANIES_PRODUCT_FILTER_MINI_KASKO: 'insurance-companies-filter-product-mini-kasko',
  INSURANCE_COMPANIES_PRODUCT_FILTER_PETS: 'insurance-companies-filter-product-pets',
};

export const INSURANCE_COMPANIES_PARTNER_FILTER_EVENTS = {
  INSURANCE_COMPANIES_PARTNER_FILTER_ALL: 'insurance-companies-filter-partner-all',
  INSURANCE_COMPANIES_PARTNER_FILTER_MAIN: 'insurance-companies-filter-partner-main',
};

export const INSURANCE_COMPANIES_PERIOD_FILTER_EVENTS = {
  INSURANCE_COMPANIES_PERIOD_FILTER_CURRENT_MONTH: 'insurance-companies-filter-period-current-month',
  INSURANCE_COMPANIES_PERIOD_FILTER_MONTH: 'insurance-companies-filter-period-month',
  INSURANCE_COMPANIES_PERIOD_FILTER_WEEK: 'insurance-companies-filter-period-week',
  INSURANCE_COMPANIES_PERIOD_FILTER_DAY: 'insurance-companies-filter-period-day',
  INSURANCE_COMPANIES_PERIOD_FILTER_DATES_RANGE: 'insurance-companies-filter-period-dates-range',
};
